import { memo, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

const NoteDropdown = ({ value = '', onChange, placeholder = 'Add Note', suggestions = [] }) => {
  const [open, setOpen] = useState(false);
  const [dropPos, setDropPos] = useState(null);
  const ref = useRef(null);
  useClickAway(ref, () => setOpen(false));

  const seen = new Set();
  const filtered = (value
    ? suggestions.filter((n) => n.note.toLowerCase().includes(value.toLowerCase()))
    : suggestions
  ).filter((n) => {
    const key = n.note.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  const capturePos = () => {
    if (ref.current) {
      const r = ref.current.getBoundingClientRect();
      setDropPos({ top: r.bottom, left: r.left, width: r.width });
    }
  };

  return (
    <div
      ref={ref}
      className="eye-note-dropdown"
      onClick={() => {
        if (!open) {
          capturePos();
          setOpen(true);
        }
      }}
    >
      <i className="fas fa-search eye-note-icon" />
      {open ? (
        <>
          <input
            autoFocus
            className="eye-note-field"
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          {filtered.length > 0 && dropPos && (
            <ul
              className="eye-note-suggestions"
              style={{ position: 'fixed', top: dropPos.top, left: dropPos.left, width: dropPos.width, right: 'auto', zIndex: 9999 }}
              onMouseDown={(e) => e.stopPropagation()}
            >
              {filtered.map((n) => (
                <li
                  key={n.id || n._id}
                  className="eye-note-suggestion-item"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange(n.note);
                    setOpen(false);
                  }}
                >
                  {n.note}
                </li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <span className={`eye-note-text${value ? '' : ' eye-note-ph'}`}>
          {value || placeholder}
        </span>
      )}
      <i
        className="fa fa-angle-down arrow-angle cursor-pointer"
        aria-hidden="true"
        onClick={(e) => {
          e.stopPropagation();
          if (!open) capturePos();
          setOpen((v) => !v);
        }}
      />
    </div>
  );
};

export default memo(NoteDropdown);
